import type { JSX } from 'react';
import { generatePath } from 'react-router';

import { Link } from 'Components/Buttons/Buttons';
import { CollapsibleModal } from 'Components/Modal/CollapsibleModal/CollapsibleModal';
import { RISK_DETAILS } from 'Config/PathTemplates';
import { AssociatedRisk } from 'Models/Actions';

import styles from './MappedRisksModal.module.css';

export interface MappedRisksModalProps {
    hideModal: () => void;
    associatedRisks: AssociatedRisk[];
}

export const MappedRisksModal = (props: MappedRisksModalProps): JSX.Element => {
    const risksList = props.associatedRisks.map((risk, index) => (
        <div key={index} className={styles.linkContainer}>
            <Link size="sm" to={generatePath(RISK_DETAILS, { risk_id: risk.id })}>{`${risk.title} - ${risk.category.title}`}</Link>
        </div>
    ));
    return <CollapsibleModal hideModal={props.hideModal} headerText={{ text: 'Risks Mapped' }} displayItems={risksList} />;
};
